import React from "react";
import { Link } from "react-router-dom";

class Page1 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 1) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div className="container-fluid h-100 vertical-center ">
            <div className="row h-100 justify-content-center">
              <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                <div className="card mb-4 box-shadow" id="pageContent">
                  <div className="card-body d-flex flex-column text-dark">
                    <span id="moduleContentText_2">
                      If you completed the{" "}
                      <Link to="/Module1" target="_blank">
                        'I have no idea what I want to do'
                      </Link>{" "}
                      section of this course, by now you should have a shopping
                      list of what is important to you in your future career and
                      what you’re good at along with a few options you wish to
                      explore.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page1;
